import { z } from 'zod'

/** How credit was bought: on Stripe's checkout page, from an AI agent's wallet, or by auto-reload. */
export const BILLING_PURCHASE_SOURCES = ['checkout', 'wallet', 'auto_reload'] as const

export const billingPurchaseSourceSchema = z.enum(BILLING_PURCHASE_SOURCES)

export type BillingPurchaseSource = z.infer<typeof billingPurchaseSourceSchema>

export const PRISMA_BILLING_PURCHASE_SOURCES = ['CHECKOUT', 'WALLET', 'AUTO_RELOAD'] as const

export type PrismaBillingPurchaseSource = (typeof PRISMA_BILLING_PURCHASE_SOURCES)[number]

export const BILLING_PURCHASE_SOURCE_FROM_PRISMA = {
  CHECKOUT: 'checkout',
  WALLET: 'wallet',
  AUTO_RELOAD: 'auto_reload',
} as const satisfies Record<PrismaBillingPurchaseSource, BillingPurchaseSource>

export const BILLING_PURCHASE_SOURCE_TO_PRISMA = {
  checkout: 'CHECKOUT',
  wallet: 'WALLET',
  auto_reload: 'AUTO_RELOAD',
} as const satisfies Record<BillingPurchaseSource, PrismaBillingPurchaseSource>
